"use strict";

exports.__esModule = true;
exports.default = void 0;
var memoize = function memoize(fn) {
  var cache = new Map();
  return function (arg) {
    if (!cache.has(arg)) {
      // @FlowFixMe: "Function" is not type safe, but what to use for genereic functions...?
      cache.set(arg, fn(arg));
    }
    return cache.get(arg);
  };
};
var _default = exports.default = memoize;